export const education = [
	{
		school: 'Universidad De Manila',
		program: 'Bachelor of Science in Information Technology',
		honor: 'Cum Laude',
		period: '2021 - 2025',
	},
	{
		school: 'La Consolacion College Manila',
		program: 'Information and Communications Technology (ICT)',
		honor: 'With Honors',
		period: '2019 - 2021',
	},
];

// Recognition first (shown with a `badge`); seminars after, newest first.
// Entries without a `file` have no certificate and render without a link.
export const certificates = [
	{ title: 'IT 13th Skill Olympics — Web Designing (UDM Representative)', date: 'November 22, 2024', file: '/certificates/itOlympicCert.pdf', badge: 'competition' },
	{ title: 'Thesis Defense Panelist — reservation & booking website (invited by capstone adviser)', date: '4th year, 2024 - 2025', badge: 'panelist' },
	{ title: 'The Vision of 6G Networks in the Future', date: 'May 18, 2024', file: '/certificates/6gCert.pdf' },
	{ title: 'AI and Internet of Things', date: 'May 11, 2024', file: '/certificates/aiAndIotCert.pdf' },
	{ title: 'The Evolving CyberSecurity Threat Landscape', date: 'April 17, 2024', file: '/certificates/cybersecThreatCert.pdf' },
	{ title: 'Search Engine Optimization (SEO) vs Search Engine Marketing (SEM)', date: 'April 9, 2024', file: '/certificates/seoVsSem.pdf' },
	{ title: 'AiLam Mo Dapat: Leveraging the Use of AI Tools in Academic Writing', date: 'March 26, 2024', file: '/certificates/aiLamMoCert.pdf' },
	{ title: 'Playing It Safe: How to Stay Secure in the Digital World', date: 'March 23, 2024', file: '/certificates/playingItSafeCert.pdf' },
];
